export class QXMLParam {
  constructor() {
    this.fParam = null;
    this.fValue = null;
  }

  InitParam(key, value) {
    this.fParam = key;
    this.fValue = value;
  }

  GetParamName() {
    return this.fParam;
  }

  GetParamValue() {
    return this.fValue;
  }
}
